/**
 * Vibração háptica para feedback de erro
 * Funciona em dispositivos móveis e alguns desktops modernos
 */
export const vibrateError = () => {
  if ('vibrate' in navigator) {
    // Padrão: vibrar-pausar-vibrar para indicar erro
    navigator.vibrate([50, 30, 50]);
  }
};

/**
 * Vibração suave para sucesso
 */
export const vibrateSuccess = () => {
  if ('vibrate' in navigator) {
    navigator.vibrate(100);
  }
};
